<template>
	<div class="col-12">
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Lista de Usuarios</h3>
				<div class="card-tools">
                    <div class="text-right d-flex align-items-center justify-content-end">
                        

                        <ImportUserComponentVue />
                        <router-link to="/users/upload-receipts" v-can="'import_receipts_payroll'" class="btn btn-sm m-1 btn-outline-info">
                            <i class="fas fa-file-upload"></i> Cargar recibos
                        </router-link>
                        <!-- <a @click="showImport()" v-can="'import_users'" class="btn btn-sm m-1 btn-outline-success">
                            <i class="fa fa-file-excel"></i> Importar
                        </a> -->
                        <router-link :to="`/users/form`" v-can="'add_users'" class="btn btn-sm m-1 btn-outline-success">
                            <i class="fa fa-plus"></i> Usuario
                        </router-link>
                        <button @click="exportUsers()" v-can="'users'" class="btn btn-sm m-1 btn-outline-success">
                            <i class="fas fa-file-excel"></i> Exportar usuarios
                        </button>
                        <button @click="openExportModal()" v-can="'sensitive_data'" class="btn btn-sm m-1 btn-outline-info">
                            <i class="fas fa-file-excel"></i> Excel Asistencia
                        </button>
                    </div>
				</div>
			</div>
			<div class="card-body">
				<!-- Team Filter Active Indicator -->
				<div v-if="filters.user_id" class="alert alert-info d-flex justify-content-between align-items-center mb-3">
					<span>
						<i class="fas fa-users mr-2"></i>
						Filtro activo para el equipo de <strong>{{ teamLeaderName || 'Cargando...' }}</strong>
					</span>
					<button class="btn btn-sm btn-info" @click="clearTeamFilter()">
						<i class="fas fa-times mr-1"></i> Quitar filtro
					</button>
				</div>

				<!-- Filters Section -->
				<div class="row mb-3">
					<div class="col-md-3 mb-2">
						<label>Buscar:</label>
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="search" @keyup="list()" placeholder="Nombre, correo, teléfono..." />
                            <div class="input-group-append">
                                <button v-can="'sensitive_data'" class="btn btn-outline-info" @click="openAdvancedSearch" title="Búsqueda Avanzada" type="button">
                                    <i class="fas fa-search-plus"></i>
                                </button>
                            </div>
                        </div>
                        <small v-if="Object.keys(advancedFilters).length > 0" class="text-info cursor-pointer d-block mt-1" @click="advancedFilters = {}; list()">
                            <i class="fas fa-filter"></i> Filtros activos (Limpiar)
                        </small>
					</div>
					<div class="col-md-3 mb-2">
						<label>Área:</label>
						<select class="form-control" v-model="filters.area_id" @change="list()">
							<option value="">Todas</option>
							<option v-for="area in areas" :key="area.id" :value="area.id">
								{{ area.name }}
							</option>
						</select>
					</div>
					<div class="col-md-3 mb-2">
						<label>Perfil:</label>
						<select class="form-control" v-model="filters.profile_id" @change="list()">
							<option value="">Todos</option>
							<option v-for="profile in profiles" :key="profile.id" :value="profile.id">
								{{ profile.name }}
							</option>
						</select>
					</div>
					<div class="col-md-3 mb-2">
						<label>Estatus:</label>
						<select class="form-control" v-model="filters.status_id" @change="list()">
							<option value="">Todos</option>
							<option v-for="status in statuses" :key="status.id" :value="status.id">
								{{ status.name }}
							</option>
						</select>
					</div>
				</div>

				<!-- Results Info -->
				<div class="row mb-2" v-if="users.total">
					<div class="col-8">
						<small class="text-muted">
							Mostrando {{ users.from }} - {{ users.to }} de {{ users.total }} usuarios
						</small>
					</div>
					<div v-can="'sensitive_data'" class="col-4 text-right">
                        <div class="dropdown d-inline-block mr-2">
                            <button class="btn btn-sm btn-secondary dropdown-toggle shadow-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="background-color: #6c757d; border-color: #6c757d;">
                                <i class="fas fa-columns"></i> Columnas
                            </button>
                            <div class="dropdown-menu dropdown-menu-right p-3 shadow-lg border-0" aria-labelledby="dropdownMenuButton" style="min-width: 280px; max-height: 500px; overflow-y: auto;" @click.stop>
                                <h6 class="dropdown-header font-weight-bold text-uppercase text-secondary pl-0 mb-2" style="letter-spacing: 0.5px; font-size: 0.75rem;">Mostrar/Ocultar Campos</h6>
                                
                                <div v-for="col in extraColumnsDefinition" :key="col.key" class="custom-control custom-switch mb-3 pl-0 d-flex justify-content-between align-items-center">
                                    <label class="text-dark d-flex align-items-center mb-0" :for="'chk-' + col.key" style="font-size: 0.95rem; cursor: pointer; flex: 1;">
                                        <i :class="col.icon + ' text-secondary mr-3'" style="width: 25px; text-align: center;"></i>
                                        <span class="font-weight-normal">{{ col.label }}</span>
                                    </label>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" :id="'chk-' + col.key" :value="col.key" v-model="visibleExtraColumns">
                                        <label class="custom-control-label" :for="'chk-' + col.key"></label>
                                    </div>
                                </div>

                                <div class="dropdown-divider my-2"></div>
                                <div class="text-right">
                                    <a href="#" class="small text-danger font-weight-bold" @click.prevent="visibleExtraColumns = []" style="text-decoration: none;">
                                        <i class="fas fa-trash-alt mr-1"></i> Restablecer vista
                                    </a>
                                </div>
                            </div>
                        </div>
					</div>
				</div>

				<!-- Table -->
				<div class="table-responsive">
					<table class="table table-hover table-bordered user-table">
						<thead class="thead-light">
							<tr>
								<th class="text-center" style="width: 100px;">No. Empleado</th>
								<th style="width: 250px;">Nombre</th>
								<th class="text-center" style="width: 180px;">Área</th>
								<th class="text-center" style="width: 180px;">Perfil</th>
								<th class="text-center" style="width: 140px;">Teléfono</th>
								<th class="text-center" style="width: 100px;">Estatus</th>
								<th class="text-center" style="width: 120px;">Fecha Ingreso</th>
                                <th v-for="col in resolvedExtraColumns" :key="col.key" class="text-center" style="min-width: 120px;">{{ col.label }}</th>
								<th class="text-center" style="width: 120px;">Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td colspan="8" class="text-center p-5">
									<i class="fas fa-spinner fa-pulse fa-3x text-primary"></i>
									<h6 class="mt-3 text-muted">Cargando usuarios...</h6>
								</td>
							</tr>
						</tbody>
						<tbody v-else-if="users && users.data && users.data.length">
							<tr v-for="(user, index) in users.data" :key="index" class="user-row">
								<td class="text-center align-middle">
									<span class="badge badge-light border employee-badge">
										{{ user.no_employee || 'N/A' }}
									</span>
								</td>
								<td class="align-middle">
								<div class="user-name hint--top hint--rounded" :aria-label="user.name + (user.last_name ? ' ' + user.last_name : '')">{{ user.name.split(' ')[0]+ ' '+ user.last_name.split(' ')[0] }}</div>
								<div class="user-email">{{ user.email }}</div>
							</td>
								<td class="text-center align-middle">
									<span v-if="user.area" class="area-name">
										{{ user.area.name }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.profile" class="profile-name">{{ user.profile.name }}</span>
									<span v-else class="text-muted">Sin perfil</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.phone" class="phone-number">
										{{ user.phone }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.status" :class="getStatusBadgeClass(user.status.id)" class="status-badge">
										{{ user.status.name }}
									</span>
									<span v-else class="badge badge-secondary">N/A</span>
								</td>
								<td class="text-center align-middle">
									<span v-if="user.admission_date" class="date-text">
										{{ user.admission_date | dateSimple }}
									</span>
									<span v-else class="text-muted">-</span>
								</td>
                                <td v-for="col in resolvedExtraColumns" :key="col.key" class="text-center align-middle">
                                    <span v-if="col.key === 'usa_visa'">
                                        {{ user[col.key] == 1 ? 'Sí' : 'No' }}
                                    </span>
                                    <span v-else-if="col.key === 'salary'">
                                        {{ user[col.key] | Money }}
                                    </span>
                                     <span v-else-if="col.key === 'admission_date'">
                                        {{ user[col.key] | dateSimple }}
                                    </span>
                                    <span v-else>
                                        {{ user[col.key] || '-' }}
                                    </span>
                                </td>
								<td class="text-center align-middle">
									<div class="btn-group" role="group">
                                        <router-link :to="`/users/form/${user.id}`" v-if="canViewUsersOnly" class="btn btn-outline-info btn-sm" title="Ver detalle">
                                            <i class="fas fa-eye"></i>
                                        </router-link>
										<router-link :to="`/users/form/${user.id}`" v-can="'edit_users'" class="btn btn-outline-primary btn-sm" title="Editar">
											<i class="fas fa-edit"></i>
										</router-link>
										<button type="button" @click="deleted(user.id)" v-can="'deleted_users'" class="btn btn-outline-danger btn-sm" title="Eliminar">
											<i class="fa fa-trash"></i>
										</button>
										<router-link v-if="user.subordinates_count > 0" :to="`/users?user_id=${user.id}`" class="btn btn-outline-info btn-sm" title="Su equipo">
											<i class="fas fa-users"></i>
										</router-link>
									</div>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="8" class="p-5">
									<i class="fas fa-inbox fa-3x text-muted mb-3"></i>
									<h6 class="text-muted">No se encontraron resultados.</h6>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination v-if="users && users.total" v-model="page" :records="users.total" :per-page="users.per_page" @paginate="list" />                       			
			</div>
		</div>
    <AdvancedSearchModal @search="handleAdvancedSearch" />
    <AttendanceExportModal @confirm="handleConfirmExport" />
	</div>
</template>

<script>
/* eslint-disable no-undef */
import request from '@/services/request';
import {  mapMutations, mapActions } from 'vuex';
import ImportUserComponentVue from '@/component/ImportUserComponent.vue'
import Pagination from 'vue-pagination-2';
import { checkPermission } from '@/helpers/acl';

export default {
	name: "users-table",
	components: {
		Pagination,
		ImportUserComponentVue,
        AdvancedSearchModal: () => import('./AdvancedSearchModal.vue'),
        AttendanceExportModal: () => import('./AttendanceExportModal.vue')
	},
	data() {
		return {
            page:1,
			users: {},
			search: '',
            load: false,
			filters: {
				area_id: '',
				profile_id: '',
				status_id: '',
				user_id: ''
			},
			teamLeaderName: '',
            advancedFilters: {},
			areas: [],
			profiles: [],
			statuses: [],
            visibleExtraColumns: [],
            extraColumnsDefinition: [
                { key: 'rfc', label: 'RFC', icon: 'fas fa-id-card' },
                { key: 'nationality', label: 'Nacionalidad', icon: 'fas fa-globe-americas' },
                { key: 'gender', label: 'Género', icon: 'fas fa-venus-mars' },
                { key: 'marital_status', label: 'Estado Civil', icon: 'fas fa-ring' },
                { key: 'usa_visa', label: 'Visa USA', icon: 'fas fa-passport' },
                { key: 'hiring_scheme', label: 'Esquema', icon: 'fas fa-file-contract' },
                { key: 'workday_type', label: 'Jornada', icon: 'fas fa-clock' },
                { key: 'salary', label: 'Salario', icon: 'fas fa-money-bill-wave' },
                { key: 'computer_brand', label: 'Marca PC', icon: 'fas fa-laptop' },
                { key: 'computer_serial', label: 'Serie PC', icon: 'fas fa-barcode' },
                { key: 'education_level', label: 'Nivel Educativo', icon: 'fas fa-graduation-cap' },
                { key: 'degree_title', label: 'Título', icon: 'fas fa-scroll' },
                { key: 'english_level', label: 'Inglés', icon: 'fas fa-language' }
            ]
		}
	},
	mounted() {
		if (this.$route.query.user_id) {
			this.filters.user_id = this.$route.query.user_id;
		}
		this.list();
		this.setHeaderTitle('Usuarios');
		this.loadCatalogues();
		if (this.filters.user_id) {
			this.loadTeamLeaderName(this.filters.user_id);
		}
	},
	created() {
			Event.$on("event-load-users", () => {
					this.list();
			});
	},
	computed: {

        canViewUsersOnly() {
             return !checkPermission('edit_users') && checkPermission('view_users');
        },
        resolvedExtraColumns() {
            return this.extraColumnsDefinition.filter(col => this.visibleExtraColumns.includes(col.key));
        }
    },
    watch: {
		'$route.query.user_id': {
			handler(newVal) {
				this.filters.user_id = newVal || '';
                
                // Reset all other filters when entering team view to avoid "no results" confusion
                if (newVal) {
                    this.search = '';
                    this.filters.area_id = '';
                    this.filters.profile_id = '';
                    this.filters.status_id = '';
                    this.advancedFilters = {};
                }
                
                // Load the team leader name
                if (newVal) {
                    this.loadTeamLeaderName(newVal);
                } else {
                    this.teamLeaderName = '';
                }
                
				this.list();
			},
			immediate: false
		}
	},
	methods: {
        openExportModal() {
            $('#attendanceExportModal').modal('show');
        },
        async exportUsers() {
            const params = {
                ...this.filters,
                ...this.advancedFilters,
                _search: this.search,
                extra_columns: this.visibleExtraColumns.join(',')
            };
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });
            this.$swal.showLoading();
            try {
                const response = await request.get('/users/export', params, { responseType: 'blob' });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `usuarios_${new Date().toISOString().slice(0,10).replace(/-/g,'')}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.$swal.close();
                this.successNotification('Excel generado exitosamente.');
            } catch (error) {
                this.$swal.close();
                console.error('Export error:', error);
                this.errorNotification('No se pudo generar el Excel.');
            }
        },
        /**
         * Maneja la confirmación del modal de exportación.
         * 
         * Realiza una petición autenticada (JWT) mediante Axios con responseType 'blob'
         * para descargar el reporte de asistencia sin redirecciones y manteniendo la seguridad.
         */
        async handleConfirmExport(dates) {
            const params = {
                ...this.filters,
                ...this.advancedFilters,
                _search: this.search,
                start_date: dates.start_date,
                end_date: dates.end_date
            };
            
            // Clean empty params
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                    delete params[key];
                }
            });

            this.$swal.showLoading();
            
            try {
                const response = await request.get('/attendance/export', params, {
                    responseType: 'blob'
                });
                
                // Create a download link for the blob
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `asistencia_${dates.start_date}_a_${dates.end_date}.xlsx`);
                document.body.appendChild(link);
                link.click();
                
                // Cleanup
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.$swal.close();
                this.successNotification('Reporte generado exitosamente.');
            } catch (error) {
                this.$swal.close();
                console.error("Export error:", error);
                this.errorNotification('No se pudo generar el reporte. Verifica los permisos.');
            }
        },
		async deleted(id) {
			try {
				// Step 1: Check dependencies
				let { data } = await request.get(`/users/${id}/check-dependency`);
				
				if (data.has_subordinates) {
					// Exit Assistant Flow
					this.showExitAssistant(id, data.count);
				} else {
					// Standard Delete Flow
					this.confirmDelete(id);
				}
			} catch (error) {
				console.error(error);
				this.errorNotification('Error al verificar dependencias del usuario.');
			}
		},
		async confirmDelete(id) {
			this.$swal({
				title: 'Eliminar usuario',
				text: '¿Seguro que quiere eliminar al usuario?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Sí, eliminar',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async showExitAssistant(id, count) {
			// Get potential leaders (Peers + Direct Boss) using the specialized endpoint
			let usersResponse = await request.get(`/users/${id}/potential-leaders`);
            let potentialLeaders = usersResponse.data;

            // Create options for Swal
            let options = {};
            potentialLeaders.forEach(u => {
                options[u.id] = u.name + ' ' + (u.last_name || '');
            });

			const { value: newLeaderId } = await this.$swal({
				title: `Este usuario tiene ${count} personas a su cargo`,
				text: "Para eliminarlo, debes reasignar su equipo a otro líder.",
				icon: 'warning',
				input: 'select',
				inputOptions: options,
				inputPlaceholder: 'Selecciona al nuevo líder',
				showCancelButton: true,
				confirmButtonText: 'Reasignar y Eliminar',
                cancelButtonText: 'Cancelar',
				confirmButtonColor: '#d33', // Danger action
				inputValidator: (value) => {
					return new Promise((resolve) => {
						if (value) {
							resolve();
						} else {
							resolve('Debes seleccionar un nuevo líder');
						}
					});
				}
			});

			if (newLeaderId) {
				this.callReassignAndDelete(id, newLeaderId);
			}
		},
		async callReassignAndDelete(id, newLeaderId) {
            this.$swal.showLoading();
			try {
				let { data } = await request.post(`/users/${id}/reassign-and-delete`, { new_leader_id: newLeaderId });
				this.$swal.close();
                this.list();
				this.successNotification(data.message);
			} catch (error) {
                this.$swal.close();
				this.errorNotification(error);
			}
		},
		async callDeleted(id) {
			let _endpoint = '/users/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response;});
				this.list();
				this.successNotification(response.data.message);			
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		showImport(){
			this.$modal.show('example');
		},
		async list(page = 1) {
            this.load = true;
			let service = request;
			let search = this.search;
			let _endpoint = '/users';
			
			// Build query params
			let params = {
				page: page,
				_search: search,
				area_id: this.filters.area_id,
				profile_id: this.filters.profile_id,
				status_id: this.filters.status_id,
				user_id: this.filters.user_id,
                ...this.advancedFilters
			};
			
			try {
				let { data } = await service.list(_endpoint, page, search, params)
				if (data) {
                    this.load = false;
					this.users = data;
				}
			} catch (error) {
				this.load = false;
				console.log(error);
			}
		},
			clearTeamFilter() {
			this.filters.user_id = '';
			this.teamLeaderName = '';
			// Update URL without reloading to keep it clean
			const query = { ...this.$route.query };
			delete query.user_id;
			
            // Use .catch to ignore NavigationDuplicated errors gracefully (Vue Router 3)
			this.$router.push({ query }).catch(err => {
                if (err.name !== 'NavigationDuplicated') console.error(err);
            });
            
			this.list();
		},
		async loadTeamLeaderName(userId) {
			try {
				const { data } = await request.get(`/users/${userId}`);
				if (data && data.name) {
					this.teamLeaderName = data.name + (data.last_name ? ' ' + data.last_name : '');
				} else {
					this.teamLeaderName = 'Usuario';
				}
			} catch (error) {
				console.error('Error loading team leader name:', error);
				this.teamLeaderName = 'Usuario';
			}
		},
        openAdvancedSearch() {
            $('#advancedSearchModal').modal('show');
        },
        handleAdvancedSearch(filters) {
            this.advancedFilters = filters;
            this.list();
        },
		async loadCatalogues() {
			try {
				// Load areas
				const areasResponse = await request.get('/catalogue/areas');
				this.areas = areasResponse.data;

				// Load profiles - using profiles_list for simple Profile models
				const profilesResponse = await request.get('/catalogue/profiles_list');
				this.profiles = profilesResponse.data;

				// Load statuses
				const statusesResponse = await request.get('/catalogue/statuses');
				this.statuses = statusesResponse.data;
			} catch (error) {
				console.error('Error loading catalogues:', error);
			}
		},
		getStatusBadgeClass(statusId) {
			// Assuming status 1 is Active, adjust based on your actual data
			if (statusId === 1) {
				return 'badge badge-success';
			} else {
				return 'badge badge-danger';
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		})
	}
}
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.user-table {
	font-size: 0.85rem;
}

.user-table thead th {
	background-color: #f8f9fa;
	border-bottom: 2px solid #dee2e6;
	font-weight: 600;
	text-transform: uppercase;
	font-size: 0.7rem;
	letter-spacing: 0.3px;
	padding: 12px 10px;
	vertical-align: middle;
	white-space: nowrap;
}

.user-table tbody td {
	padding: 12px 10px;
	vertical-align: middle;
}

.user-row {
	transition: background-color 0.2s ease;
}

.user-row:hover {
	background-color: #f8f9fa;
}

/* Employee Badge */
.employee-badge {
	padding: 0.35em 0.7em;
	font-size: 0.8rem;
	font-weight: 600;
	color: #495057;
}

/* User Name and Email */
.user-name {
	font-weight: 600;
	font-size: 0.875rem;
	color: #212529;
	margin-bottom: 3px;
}

.user-email {
	font-size: 0.75rem;
	color: #6c757d;
}

/* Area Name */
.area-name {
	color: #007bff;
	font-weight: 600;
	font-size: 0.85rem;
}

/* Profile Name */
.profile-name {
	color: #495057;
	font-size: 0.85rem;
}

/* Phone Number */
.phone-number {
	color: #495057;
	font-size: 0.8rem;
}

/* Status Badge */
.status-badge {
	padding: 0.3em 0.7em;
	font-size: 0.75rem;
	font-weight: 600;
	border-radius: 0.25rem;
}

/* Date Text */
.date-text {
	color: #495057;
	font-size: 0.8rem;
}

.btn-group .btn {
	padding: 0.3rem 0.5rem;
	font-size: 0.8rem;
}

.table-responsive {
	border-radius: 0.25rem;
}

label {
	margin-bottom: 0.25rem;
	font-size: 0.85rem;
	font-weight: 500;
}

.form-control {
	font-size: 0.85rem;
	padding: 0.4rem 0.6rem;
}

/* Filter section spacing */
.mb-3 {
	margin-bottom: 1rem !important;
}

.mb-2 {
	margin-bottom: 0.75rem !important;
}
</style>
